import { RelationalActionParameter } from "./RelationalActionParameter";
import { IFontSizeAutoAdjustable, instanceOfIFontSizeAutoAdjustable } from "./IFontSizeAutoAdjustable";

export interface IMksTemplateExecutable extends IFontSizeAutoAdjustable {
  mksTemplateFormats: RelationalActionParameter[];
  mksTemplateRegisteredId: string;  // undefinedもありうる？
  setValueFromExternalScript(value: string): void;
  adjustFontSize(): void;
  adjustObjectHeight(): void;
}

export function instanceOfIMksTemplateExecutable(instance: any): instance is IMksTemplateExecutable {
  if (!instance) { return false; }
  return (instance.mksTemplateFormats !== undefined)
    && (instance.setValueFromExternalScript !== undefined)
    && (instance.adjustFontSize !== undefined)
    && (!instance.adjustObjectHeight !== undefined)
    && (instanceOfIFontSizeAutoAdjustable(instance));
}
